// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 181 ? "resume-pdf-renderer" : chunkId) + ".chunk.js";
};